import styled from '@emotion/styled';
import { mainColors, navigation } from 'src/assets/colors';

export const ReportsWrapper = styled.section`
    margin: 5px 5px 5px 0;
    padding: 15px;
    background-color: ${navigation.bgColorTab};
`;

export const ReportsFilter = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Card = styled.div`
    background-color: ${mainColors.default.light};
    border: 1px solid ${mainColors.grays.gray300};
    border-radius: 8px;
    padding: 16px;
    max-width: 980px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CardTitle = styled('h3', { label: 'CardTitle' })`
    font-size: 18px;
    font-weight: 700;
    color: ${mainColors.main.primary};
    margin: 0;
`;

export const ControlsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 12px;
    align-items: end;
`;

export const DateField = styled.div`
    min-width: 220px;
`;

export const AlertsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
